import { render } from "./MoneyInput.vue?vue&type=template&id=d5816cf8"
import script from "./MoneyInput.vue?vue&type=script&lang=js"
export * from "./MoneyInput.vue?vue&type=script&lang=js"

import "./MoneyInput.vue?vue&type=style&index=0&id=d5816cf8&lang=css"

import exportComponent from "/home/runner/work/tom/tom/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__